<template>
  <div>
    <div class="topbar">
      <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
      <div class="clearfix main-wrap">
        <h1>家长({{parentsNum}})</h1>
        <!-- <span class="pull-right icon-right" @click="showMore()">更多</span> -->
      </div>
      <div class="liner"></div>
    </div>


    <!-- <mt-loadmore :top-method="loadTop"> -->
    <div class="main-page" style="padding-bottom:0">
      <mt-index-list>
      <mt-index-section :index="firstCharList.firstChar" v-for="firstCharList in studentFirstCharList">
         <li class="list-group-item large">
            <div class="list-group" v-for="student in firstCharList.students">
              <div class="liner"></div>
              <div class="family clearfix">
                <router-link class="child" :to="{path: '/student/detail/' + student.studentId}" tag="div">
                  <img :src="student.image_address ? (student.baseAcessPath + student.image_address) : img_default" width="40" height="40"/>
                  <span class="block">{{student.studentName}}</span>
                </router-link>
                <div class="parents">
                  <div class="clearfix line-y" style="padding:0 0 0 10px;">

                    <span class="pull-left text-center" v-for="parent in student.parentList" @click="showParentDialog(parent.parentRole, parent.phoneNum, student.studentId, student.studentName)">
                      <img :src="img_default">
                      <cite class="gray font-12">{{parent.parentRole}}</cite>
                    </span>

                    <span class="pull-left text-center" v-if="student.parentList.length == 0 && student.parentPhone" @click="showParentDialog(student.parentRole, student.parentPhone, student.studentId, student.studentName)">
                      <img :src="img_default">
                      <small class="font-10">未激活</small>
                      <cite class="gray font-12">{{student.parentRole}}</cite>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </mt-index-section>
      </mt-index-list>
    </div>
    <!-- </mt-loadmore> -->

    <div class="fixediv mail">
      <span class="img-mail"></span>
    </div>

    <div class="maskdiv" v-show="!isHideParentDialog" @click="isHideParentDialog = true">
      <div class="popover">
        <div class="pop-wrap pop-parents">
          <div class="clearfix margin-x-15">
            <div class="col-xs-4"><span class="block img-wrap small" style="margin:0 auto"><img :src="img_default" width="40"></span></div>
            <div class="col-xs-6">
              <p class="font-16">{{dialogStudentName}}{{dialogParentInfo.parentRole}}</p>
              <p class="gray">{{dialogParentInfo.parentPhone}}</p>
            </div>
          </div>
          <div class="liner margin-15"></div>
          <div class="clearfix  text-center font-12 gray">
            <a class="col-xs-6" :href="'tel:' + dialogParentInfo.phoneNum"><i class="img-call"></i>呼叫</a>
            <a class="col-xs-6" :href="'sms:' + dialogParentInfo.phoneNum"><i class="img-message"></i>短信</a>
          </div>
        </div>
      </div>
    </div>



    <!-- <div class="maskdiv" v-show="!isHideStudentDialog" @click="isHideStudentDialog = true">
      <div class="slider">
        <div class="searchbar clearfix margin-15 hide">
          <input type="search" placeholder="请输入名称" v-model="filterStudentName"/>
          <span class="btn-search" style="position: relative" @click="filterByName()">搜索</span>
        </div>
        <div>
          <ul class="clearfix tabs">
            <li class="col-xs-6" v-bind:class="{'active': filterClassSfzt == '在托'}" @click="filterClassSfzt = '在托', isHideStudentDialog = true, filterStudentName = '', filterClassList()"><span class="block text-center">在托学生</span></li>
            <li class="col-xs-6" v-bind:class="{'active': filterClassSfzt == '离托'}" @click="filterClassSfzt = '离托', isHideStudentDialog = true, filterStudentName = '', filterClassList()"><span class="block text-center">离托学生</span></li>
          </ul>
          <div class="liner"></div>

          <ul class="list-group-item tinny">
            <li class="list-group" @click="filterClassId = -1, filterStudentName = '', filterClassList()">
              <span class="group-txt">全部<i class="img-checkbox pull-right" v-bind:class="{'checked': filterClassId == -1}"></i></span>
              <div class="liner"></div>
            </li>
            <li class="list-group" v-for="classInfo in classList" @click="filterClassId = classInfo.classId, filterStudentName = '', filterClassList()">
              <span class="group-txt">{{classInfo.className ? classInfo.className : '暂未分班'}}<i class="img-checkbox pull-right" v-bind:class="{'checked': filterClassId == classInfo.classId}"></i></span>
              <div class="liner"></div>
            </li>
          </ul>

          <div class="text-center hide">
            <a class="button button-line navy" @click.prevent="filterStudentName = '', filterClassList()">确定</a>
          </div>
        </div>
      </div>
    </div> -->
  <div>
</template>

<script>
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    studentFirstCharList: 'studentsAndParentsByFirstChar',
    parentsNum: 'parentsNum'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_student_list_para: service.setPara('getStudentList'),
      curcheId: 0,
      filterClassId: -1,
      filterClassSfzt: '在托',
      filterStudentName: '',
      classListJson: '',
      // classList: [],
      nowClassList: [],
      dialogParentInfo: {},
      dialogStudentId: 0,
      dialogStudentName: '',
      isHideParentDialog: true,
      isHideStudentDialog: true,
      popupVisibleParentMore: false
      // parentsNum: 0
    }
  },
  mounted: function () {
    this.curcheId = this.cookie_login_data.curcheId

    this.findStudentParent(true, false)
  },
  methods: {
    ...mapMutations([
      'receiveStudentsAndParents'
    ]),
    loadTop (id) {
      this.findStudentParent(true, true)
      this.$refs.loadmore.onTopLoaded(id)
    },
    findStudentParent (isIndicator = false, reload = false) {
      // if (this.nowClassList.length > 0) {
      //   return
      // }
      // if (reload) {
      //   this.classList = []
      // }
      this.get_student_list_para.curcheId = this.curcheId
      this.get_student_list_para.context = this
      // this.receiveStudentsAndParents(this.get_student_list_para)
      this.$store.dispatch('receiveStudentsAndParents', this.get_student_list_para)

      // console.log('数据开始获取' + new Date().format('yyyy-MM-dd hh:mm:ss'))
      // // let that = this
      // let obj = {context: this, para: this.get_student_list_para, isIndicator: isIndicator, successFun: (response) => {
      //   console.log('数据获取结束' + new Date().format('yyyy-MM-dd hh:mm:ss'))
      //   var list = response.data
      //   this.parentsNum = 0
      //   this.receiveStudentsAndParents(list)
        // for (var i = 0; i < list.length; i++) {
        //   this.parentsNum += list[i].parentList.length
        //   var className = list[i].relation_className
        //   var classId = list[i].class_id
        //   var flag = false
        //   for (var j = 0; j < that.classList.length; j++) { // 按班级归类
        //     if (!classId) {
        //       that.classList[j].studentList.push(list[i])
        //       flag = true
        //       break
        //     } else if (that.classList[j].classId === classId) {
        //       that.classList[j].studentList.push(list[i])
        //       flag = true
        //       break
        //     }
        //   }
        //   if (!flag) {
        //     var classArray = {}
        //     classArray.className = className
        //     classArray.classId = classId
        //     classArray.studentList = []
        //     classArray.studentList.push(list[i])
        //     that.classList.push(classArray)
        //   }
        // }
        // that.classListJson = JSON.stringify(that.classList)
        // // that.classListJson = that.classList
        // that.filterClassList(true)
      // }}
      // service.request(obj)
    },
    // filterClassList: function () { // 筛选
    //   var tempArray = JSON.parse(this.classListJson)
    //   // var tempArray = this.classListJson

    //   if ($.trim(this.filterStudentName) != '') { // 根据关键字查找，查找全部学生
    //     for (var y = 0; y < tempArray.length; y++) {
    //       var studentListFilterName = []
    //       for (var h = 0; h < tempArray[y].studentList.length; h++) {
    //         var studentName = $.trim(tempArray[y].studentList[h].studentName)
    //         if (studentName.indexOf(this.filterStudentName) != -1) {
    //           studentListFilterName.push(tempArray[y].studentList[h])
    //         }
    //       }
    //       tempArray[y].studentList = studentListFilterName
    //     }
    //   } else {
    //     if (this.filterClassId !== -1) {
    //       for (var j = 0; j < tempArray.length; j++) {
    //         if (tempArray[j].classId === this.filterClassId) {
    //           var temp = tempArray[j]
    //           tempArray = []
    //           tempArray.push(temp)
    //           break
    //         }
    //       }
    //     }
    //     if (this.filterClassSfzt) {
    //       for (var z = 0; z < tempArray.length; z++) {
    //         var studentList = []
    //         for (var x = 0; x < tempArray[z].studentList.length; x++) {
    //           var sfzt = $.trim(tempArray[z].studentList[x].sfzt)
    //           if (sfzt === this.filterClassSfzt) {
    //             studentList.push(tempArray[z].studentList[x])
    //           }
    //         }
    //         tempArray[z].studentList = studentList
    //       }
    //     }
    //   }
    //   this.nowClassList = tempArray
    //   console.log('数据展示结束' + new Date().format('yyyy-MM-dd hh:mm:ss'))
    // },
    showParentDialog: function (parentRole, parentPhone, studentId, studentName) {
      this.dialogStudentId = studentId
      this.dialogStudentName = studentName
      var item = {}
      item.parentRole = parentRole
      item.parentPhone = parentPhone
      this.dialogParentInfo = item
      this.isHideParentDialog = false
    }
    // showMore: function () {
    //   this.isHideStudentDialog = false
    // },
    // filterByName: function () {
    //   this.filterClassId = 0
    //   this.filterClassSfzt = ''
    //   this.filterClassList()
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// parent.vue?3e7cd658